"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropDown = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../shared/typography");
const icons_1 = require("../../atoms/icons");
const SubOptions = ({ options, title, onCloseMenu }) => {
    const [show, toggleShow] = (0, react_1.useState)(false);
    const [sectionWidth, setWidth] = (0, react_1.useState)(0);
    const onClick = (e) => {
        e.stopPropagation();
        if (!e.target.closest(".option"))
            return;
        toggleShow(!show);
    };
    const sectionRef = (0, react_1.createRef)();
    (0, react_1.useEffect)(() => {
        var _a;
        if (show) {
            const clientWidth = ((_a = sectionRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) || 100;
            setWidth(clientWidth + 2);
        }
    }, [show, sectionWidth]);
    return ((0, jsx_runtime_1.jsxs)(SubOptionListItem, { "data-cy": "top-nav-right-option", onClick: onClick, sectionWidth: sectionWidth, show: show, children: [(0, jsx_runtime_1.jsxs)(typography_1.H4, { className: "option", children: [(0, jsx_runtime_1.jsx)("p", { children: title }, void 0), (0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangleSmall", icon: ["fal", "chevron-right"] }, void 0)] }, void 0), show && ((0, jsx_runtime_1.jsx)("section", { ref: sectionRef, children: options.map(renderOption(onCloseMenu)) }, void 0)), (0, jsx_runtime_1.jsx)("div", {}, void 0)] }, title));
};
const renderOption = (onCloseMenu) => (option, index) => {
    if ("title" in option) {
        return ((0, jsx_runtime_1.jsx)(SubOptions, { ...option, onCloseMenu: onCloseMenu }, "options" + index));
    }
    return ((0, jsx_runtime_1.jsxs)(OptionsListItem, { "data-cy": "top-nav-right-option", children: [(0, jsx_runtime_1.jsx)(typography_1.H4, { onClick: onCloseMenu, children: option }, void 0), (0, jsx_runtime_1.jsx)("div", {}, void 0)] }, "option" + index));
};
const SubOptionListItem = styled_components_1.default.li `
  align-items: center;
  display: flex;
  flex-direction: column;
  list-style: none;
  white-space: nowrap;

  h4 {
    align-items: center;
    cursor: pointer;
    display: flex;
    height: 100%;
    justify-content: space-between;
    width: 100%;

    & > p {
      padding-left: ${({ theme }) => theme.spacings.xl};
    }
  }

  div {
    padding-right: ${({ theme }) => theme.spacings.xl};

    & li:last-of-type div {
      display: none;
    }
  }

  section {
    background-color: ${({ theme }) => theme.colors.whiteBase};
    border: 1px solid ${({ theme }) => theme.colors.silverBase};
    left: ${({ sectionWidth }) => -sectionWidth + "px"};
    bottom: -1px;
    position: absolute;
    width: unset;
    display: ${({ sectionWidth }) => (sectionWidth ? "block" : "none")};
  }

  & > div {
    border-bottom: 1px solid ${({ theme }) => theme.colors.silverBase};
    margin: ${({ theme }) => `0 ${theme.spacings.xl}`};
    width: calc(100% - 3rem);
  }
`;
const DropDown = ({ title, options }) => {
    const [isOpen, toggleOpen] = (0, react_1.useState)(false);
    const onWindowClick = (e) => {
        e.stopPropagation();
        toggleOpen(false);
    };
    (0, react_1.useEffect)(() => {
        window.addEventListener("click", onWindowClick);
        return () => window.removeEventListener("click", onWindowClick);
    }, []);
    const onClick = (e) => {
        e.stopPropagation();
        toggleOpen(!isOpen);
    };
    const onCloseMenu = () => toggleOpen(false);
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { onClick: onClick, "data-cy": "top-nav-right-menu", className: "dropdown", children: [(0, jsx_runtime_1.jsx)(typography_1.H4, { children: title }, void 0), (0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", icon: isOpen ? ["fas", "caret-up"] : ["fas", "caret-down"], color: "grey", size: "lg" }, void 0), isOpen && ((0, jsx_runtime_1.jsx)(OptionsList, { className: "options", children: options.map(renderOption(onCloseMenu)) }, void 0))] }, void 0));
};
exports.DropDown = DropDown;
const Wrapper = styled_components_1.default.div `
  align-items: center;
  display: flex;
  position: relative;
  z-index: 10;
  cursor: pointer;

  h4 {
    font-weight: 400;
    margin-right: ${({ theme }) => theme.spacings.xs};
  }
`;
const OptionsList = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.whiteBase};
  border: 1px solid ${({ theme }) => theme.colors.silverBase};
  position: absolute;
  display: inline-block;
  top: calc(100% + 12px);
  right: -8px;
  overflow: visible;
  width: auto;
  cursor: default;

  li h4 {
    margin-right: 0;
    padding: ${({ theme }) => `${theme.spacings.xs} 0`};
  }

  li:first-of-type {
    padding-top: ${({ theme }) => theme.spacings.m};
  }

  li:last-of-type {
    padding-bottom: ${({ theme }) => theme.spacings.m};
  }

  li:last-of-type h4 + div {
    display: none;
  }
`;
const OptionsListItem = styled_components_1.default.li `
  align-items: center;
  display: flex;
  flex-direction: column;
  list-style: none;
  padding: ${({ theme }) => `0  ${theme.spacings.xl}`};
  white-space: nowrap;

  h4 {
    width: 100%;
    height: 100%;

    a,
    p,
    & > div {
      cursor: pointer;
    }

    & > * {
      color: ${({ theme }) => theme.colors.greyBase};
      font-weight: 400;
      text-decoration: none;
    }

    & > div {
      align-items: center;
      display: flex;

      & > div {
        margin-right: ${({ theme }) => theme.spacings.xs};
      }
    }
  }

  h4 + div {
    border-bottom: 1px solid ${({ theme }) => theme.colors.silverBase};
    margin: ${({ theme }) => `0 ${theme.spacings.xl}`};
    width: 100%;
  }
`;
//# sourceMappingURL=DropDown.js.map